import {
  dispatcher,
  api,
  RESOURCE_CREATE_INITIALIZE,
  RESOURCE_ACTION_CREATE,
  RESOURCE_ACTION_EDIT
} from '@unicus/react-ui-kit';
import { formartOnlyNumber } from 'util/formatters';

export const PATIENT = 'PATIENT';
export const PATIENT_VIEW = 'PATIENT_VIEW';
export const PATIENT_VIEW_FINISHED = 'PATIENT_VIEW_FINISHED';
export const PATIENT_EVENT_FETCH = 'PATIENT_EVENT_FETCH';
export const PATIENT_EVENT_FETCH_FINISHED = 'PATIENT_EVENT_FETCH_FINISHED';
export const PATIENT_EVENT_UNLOAD = 'PATIENT_EVENT_UNLOAD';
export const PATIENT_VIEW_UPDATE = 'PATIENT_VIEW_UPDATE';
export const PATIENT_CREATE_ATTENDANCE = 'PATIENT_CREATE_ATTENDANCE';
export const PATIENT_EVENT_CREATE_ANNOTATION =
  'PATIENT_EVENT_CREATE_ANNOTATION';
export const PATIENT_EVENT_CREATE_ANNOTATION_FINISHED =
  'PATIENT_EVENT_CREATE_ANNOTATION_FINISHED';
export const PATIENT_EVENT_LINK_TREATMENT = 'PATIENT_EVENT_LINK_TREATMENT';
export const PATIENT_EVENT_LINK_TREATMENT_FINISHED =
  'PATIENT_EVENT_LINK_TREATMENT_FINISHED';
export const PATIENT_EVENT_SHARE = 'PATIENT_EVENT_SHARE';
export const PATIENT_EVENT_SHARE_FINISHED = 'PATIENT_EVENT_SHARE_FINISHED';
export const PATIENT_SHOW_EVENTS = 'PATIENT_SHOW_EVENTS';
export const PATIENT_SHOW_ACTIVITIES = 'PATIENT_SHOW_ACTIVITIES';
export const PATIENT_FIND_BY_USER_ID = 'PATIENT_FIND_BY_USER_ID';
export const PATIENT_FIND_BY_USER_ID_FINISHED =
  'PATIENT_FIND_BY_USER_ID_FINISHED';

export const PATIENT_SCHEDULES_FETCH = 'PATIENT_SCHEDULES_FETCH';
export const PATIENT_SCHEDULES_FETCH_FINISHED =
  'PATIENT_SCHEDULES_FETCH_FINISHED';
export const PATIENT_SHOW_SCHEDULES = 'PATIENT_SHOW_SCHEDULES';
export const PATIENT_CLOSE_SCHEDULES = 'PATIENT_CLOSE_SCHEDULES';

export const PATIENT_EVENT_PRESCRIPTION_SHOW =
  'PATIENT_EVENT_PRESCRIPTION_SHOW';
export const PATIENT_EVENT_PRESCRIPTION_CLOSE =
  'PATIENT_EVENT_PRESCRIPTION_CLOSE';

export const PATIENT_EVENT = 'PATIENT_EVENT';
export const PATIENT_EVENT_FINISHED = 'PATIENT_EVENT_FINISHED';

export const PATIENT_PRESCRIPTION_CREATE_INTEGRATED =
  'PATIENT_PRESCRIPTION_CREATE_INTEGRATED';
export const PATIENT_PRESCRIPTION_CREATE_INTEGRATED_FINISHED =
  'PATIENT_PRESCRIPTION_CREATE_INTEGRATED_FINISHED';

export const PATIENT_PRESCRIPTION_INTEGRATION =
  'PATIENT_PRESCRIPTION_INTEGRATION';

export const PATIENT_FIND = 'PATIENT_FIND';

export const PATIENT_OPEN_ANNOTATION = 'PATIENT_OPEN_ANNOTATION';
export const PATIENT_CLOSE_ANNOTATION = 'PATIENT_CLOSE_ANNOTATION';

export const PATIENT_EVENT_LIST_OPEN_FILTER = 'PATIENT_EVENT_LIST_OPEN_FILTER';
export const PATIENT_EVENT_LIST_CLOSE_FILTER =
  'PATIENT_EVENT_LIST_CLOSE_FILTER';

export const PATIENT_GET_TAGS = 'PATIENT_GET_TAGS';
export const PATIENT_GET_TAGS_FINISHED = 'PATIENT_GET_TAGS_FINISHED';

export const PATIENT_CREATE_TAG = 'PATIENT_CREATE_TAG';
export const PATIENT_CREATE_TAG_FINISHED = 'PATIENT_CREATE_TAG_FINISHED';

export const PATIENT_REMOVE_TAG = 'PATIENT_REMOVE_TAG';
export const PATIENT_REMOVE_TAG_FINISHED = 'PATIENT_REMOVE_TAG_FINISHED';

export const PATIENT_SHOW_FINANCIALENTRY = 'PATIENT_SHOW_FINANCIALENTRY';
export const PATIENT_CLOSE_FINANCIALENTRY = 'PATIENT_CLOSE_FINANCIALENTRY';

export const PATIENT_LIST_REFRESH = 'PATIENT_LIST_REFRESH';

export const getDetail = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_VIEW,
    effect: async () => api.get('patients', `${id}/detail`),
    onSuccess
  });
};

export const fetchEvents = (params, onSuccess, tenant) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_EVENT_FETCH,
    effect: async () =>
      api.fetch('patients/events', { ...params, pageSize: 20 }, tenant),
    onSuccess
  });
};

export const updateView = (data) => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_VIEW_UPDATE, 'patients', data));
};

export const showCreateAttendance = (params) => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_CREATE_ATTENDANCE, 'patients', params)
  );
};

export const unloadEvents = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_EVENT_UNLOAD, 'patients'));
};

export const createAnnotation = (patientId, data, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_EVENT_CREATE_ANNOTATION,
    effect: async () =>
      api.post(`patients/${patientId}/annotation-event`, data),
    onSuccess
  });
};

export const openAnnotation = (patient) => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_OPEN_ANNOTATION, 'patients', patient)
  );
};

export const closeAnnotation = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_CLOSE_ANNOTATION, 'patients'));
};

export const linkEventToTreatment = (eventId, treatmentId, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_EVENT_LINK_TREATMENT,
    effect: async () =>
      api.put(
        `patients/link-event-treatment/?eventid=${eventId}&treatmentid=${treatmentId}`
      ),
    onSuccess
  });
};

export const shareEvent = (eventId, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_EVENT_SHARE,
    effect: async () => api.put(`patients/share-event/?eventid=${eventId}`),
    onSuccess
  });
};

export const showEvents = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_SHOW_EVENTS, 'patients'));
};

export const showActivities = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_SHOW_ACTIVITIES, 'patients'));
};

export const initializeCreate = (data) => (dispatch) => {
  dispatch(
    dispatcher.createAction(RESOURCE_CREATE_INITIALIZE, 'patients', {
      initialValues: data,
      action: data?.id ? RESOURCE_ACTION_EDIT : RESOURCE_ACTION_CREATE
    })
  );
};

export const find = (userId, onSuccess, onFail) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_FIND_BY_USER_ID,
    effect: async () => api.get('patients', `find/?userId=${userId}`),
    onSuccess,
    onFail
  });
};

export const showSchedules = (patientId) => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_SHOW_SCHEDULES, 'patients', patientId)
  );
};

export const closeSchedules = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_CLOSE_SCHEDULES, 'patients'));
};

export const showEventPrescription = (patientId) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      PATIENT_EVENT_PRESCRIPTION_SHOW,
      'patients',
      patientId
    )
  );
};

export const closeEventPrescription = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_EVENT_PRESCRIPTION_CLOSE, 'patients')
  );
};

export const createEvent = (id, data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_EVENT,
    effect: async () => api.post(`patients/${id}/event`, data),
    onSuccess
  });
};

export const createIntegratedPrescription = (data, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_PRESCRIPTION_CREATE_INTEGRATED,
    effect: async () => api.post('patients/integrated-prescription', data),
    onSuccess
  });
};

export const syncDigitalEventPrescription = (
  patientId,
  code,
  onSuccess
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_PRESCRIPTION_INTEGRATION,
    effect: async () =>
      api.post(
        `patients/sync-digital-prescription?patientId=${patientId}&code=${code}`
      ),
    onSuccess
  });
};

export const findByFederalTaxNumber = (
  federalTaxNumber,
  onSuccess,
  onFail
) => async (dispatch) => {
  const onlyNumber = formartOnlyNumber(federalTaxNumber);

  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_FIND,
    effect: async () =>
      api.get(
        'patients',
        `find-by-federal-tax-number/?federalTaxNumber=${onlyNumber}`
      ),
    onSuccess,
    onFail
  });
};

export const eventsOpenFilter = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_EVENT_LIST_OPEN_FILTER, 'patients'));
};

export const eventsCloseFilter = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_EVENT_LIST_CLOSE_FILTER, 'patients')
  );
};

export const getTags = (patientId, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_GET_TAGS,
    effect: async () => api.get('patients', `${patientId}/tags`)
  });
};

export const createTag = (patientId, data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_CREATE_TAG,
    payload: data,
    effect: async () => api.post(`patients/${patientId}/tags`, data),
    onSuccess
  });
};

export const removeTag = (patientTagId, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: PATIENT_REMOVE_TAG,
    payload: patientTagId,
    effect: async () =>
      api.del('patients', `tags?patientTagId=${patientTagId}`),
    onSuccess
  });
};

export const showFinancialEntry = (patientId) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      PATIENT_SHOW_FINANCIALENTRY,
      'financial-entries',
      patientId
    )
  );
};

export const closeFinancialEntry = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(PATIENT_CLOSE_FINANCIALENTRY, 'financial-entries')
  );
};

export const refresh = () => (dispatch) => {
  dispatch(dispatcher.createAction(PATIENT_LIST_REFRESH, 'patients'));
};
